export enum AUTH_FIELDS {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  CODE = 'code',
  AGREEMENT = 'agreement',
}
